import { QueryProvider } from '@/providers/QueryProvider';
import { AuthProvider } from '@/providers/AuthProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { OrgProvider } from '@/providers/OrgProvider';
import { AppRouter } from '@/app/router';
import { Toaster } from '@/components/ui/toaster';
import { MonitoringScope } from '@/components/monitoring/MonitoringScope';

export function App() {
  return (
    <QueryProvider>
      <ThemeProvider>
        <AuthProvider>
          <OrgProvider>
            <MonitoringScope>
              <AppRouter />
              <Toaster />
            </MonitoringScope>
          </OrgProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
